import { render, staticRenderFns } from "./CreateARecord.vue?vue&type=template&id=be2c2f76&scoped=true"
import script from "./CreateARecord.vue?vue&type=script&lang=js"
export * from "./CreateARecord.vue?vue&type=script&lang=js"
import style0 from "./CreateARecord.vue?vue&type=style&index=0&id=be2c2f76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2c2f76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be2c2f76')) {
      api.createRecord('be2c2f76', component.options)
    } else {
      api.reload('be2c2f76', component.options)
    }
    module.hot.accept("./CreateARecord.vue?vue&type=template&id=be2c2f76&scoped=true", function () {
      api.rerender('be2c2f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/messagePush/components/CreateARecord.vue"
export default component.exports